export * from './role.constant';

export const STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export const MAIL_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
  NONE: 'none',
}
